export const QD_BLUE_1 = "#13234B"
export const QD_BLUE_2 = "#25355B"
export const QD_LIGHTBLUE_1 = "#8DC1E7"
export const QD_LIGHTBLUE_2 = "#E5F1FA"
export const QD_RED_1 = "#AB192D"
export const QD_RED_2 = "#CF202F"